import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import moment from 'moment';
import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeGrid } from 'react-window';
import { showLoading } from 'src/features/videoSlice';
import VehicleTablecell from '../tables/VehicleTablecell';
import './style.css';

// Man streaming
const VehicleTable = ({ listVehicle }) => {
  const dispatch = useDispatch();
  const [rowActive, setRowActive] = useState(null);
  const deviceSerial = useSelector(state => state.videoSlice.deviceSerial);

  const vehicleMapBySerial = useMemo(() => {
    const map = new Map();
    for (const vehicle of listVehicle) {
      map.set(vehicle.device_serial, vehicle);
    }
    return map;
  }, [listVehicle]);

  const findVehicle = () => {
    return vehicleMapBySerial.get(deviceSerial);
  };

  const vehicleSelected = findVehicle();

  useEffect(() => {
    if(vehicleSelected) {
      setRowActive(vehicleSelected.device_id);
    }
  }, [vehicleSelected]);

  const handleRowClick = vehicle => {
    const vehicleId = vehicle.device_id;
    if (vehicleId) {
      setRowActive(prev => (prev === vehicleId ? null : vehicleId));
    }
    dispatch(showLoading({ device_serial: vehicle.device_serial }));
  };

  const Cell = ({ columnIndex, rowIndex, style }) => {
    const vehicle = listVehicle[rowIndex];
    if (!vehicle) return null;

    let content;
    if (columnIndex === 0) {
      content = (
        <VehicleTablecell
          row={vehicle}
          index={rowIndex}
          rowActive={rowActive}
        />
      );
    } else if (columnIndex === 1) {
      if (vehicle.debt) {
        content = (
          <span align="center" style={{ color: '#D9042F' }}>
            Hết hạn gói dịch vụ
          </span>
        );
      } else {
        content = (
          <span align="center">{Math.floor(vehicle.speed_gps) || 0}</span>
        );
      }
    } else if (columnIndex === 2) {
      if (vehicle.debt) {
        content = null;
      } else {
        content = (
          <span align="center">
            {vehicle
              ? moment.unix(vehicle.created_at).format('DD/MM HH:mm:ss')
              : '--'}
          </span>
        );
      }
    }

    const isActive = (vehicle.device_id === rowActive);

    return (
      <Box
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid #ddd',
          fontSize: '12px',
          cursor: 'pointer',
          backgroundColor: isActive ? '#FFE4E1' : '#F5F5F5'
        }}
        onClick={() => handleRowClick(vehicle)}
      >
        {content}
      </Box>
    );
  };


  return (
    <TableContainer
      component={Paper}
      className="vehicle_table"
      style={{
        maxHeight: '100%',
        width: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        border:'1px solid rgba(60, 64, 67, 0.15)',
        
      }}
    >
      <Table
        stickyHeader
        aria-label="sticky table"
        style={{
          tableLayout: 'fixed'
        }}
      >
        <TableHead
          style={{
            background: '#D9042F !important',
            color: 'white !important'
          }}
        >
          <TableRow>
            <TableCell align="center">Biển số</TableCell>
            <TableCell align="center">Vận tốc (Km/h) </TableCell>
            <TableCell align="center">Thời gian</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
            <FixedSizeGrid
              columnCount={3}
              columnWidth={119}
              height={600}
              rowCount={listVehicle.length}
              rowHeight={38}
              width={357}
            >
              {Cell}
            </FixedSizeGrid>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default React.memo(VehicleTable);
